import script from "./TransactionProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionProfile.vue?vue&type=script&setup=true&lang=js"

import "./TransactionProfile.vue?vue&type=style&index=0&id=fd48b824&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd48b824"]])

export default __exports__